import { faEllipsisVertical, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";

class AdminItemMessHome extends React.Component {
    state = {
        optActive: false
    }

    render() {
        return <li className={`admin__item admin__item--messhome ${this.props.data.isRead == false && "admin__item--noread"}`}>
            {/** Nom ou IP **/}
            <span className="admin__item__ttl">
                {
                    this.props.data.name == null ?
                        this.props.data.ip :
                        this.props.data.name
                }
            </span>

            {/** Message **/}
            <h2 className="admin__item__desc">
                {
                    this.props.data.mess
                }
            </h2>

            {/** Options **/}
            <div className={`admin__item__opts ${this.state.optActive && "admin__item__opts--active"}`}>
                {/** Voir **/}
                <Link
                    title="Voir la discussion"
                    aria-label="Voir la discussion"
                    className="admin__item__optbtn"
                    to={`/admin/tchat/discussion/${this.props.data.ip}`}
                >
                    <FontAwesomeIcon icon={faEye} />
                </Link>
            </div>

            {/** Options bouton **/}
            <button
                title={this.state.optActive ? "Fermer les options" : "Ouvrir les options"}
                aria-label={this.state.optActive ? "Fermer les options" : "Ouvrir les options"}
                className="admin__item__btnopt"
                onClick={() => this.setState({optActive: !this.state.optActive})}
            >
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </button>
        </li>
    }
}

export default AdminItemMessHome;